import { getStartOfInterval } from "@fatbees/utils";
import { useEffect, useState } from "react";

const ONE_MINUTE = 60 * 1000;

export function useQuantizedNow(interval = ONE_MINUTE): Date {
  const [result, setResult] = useState(
    getStartOfInterval(new Date(), interval),
  );

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;
    scheduleUpdate();

    return () => clearTimeout(timeout);

    function scheduleUpdate() {
      const now = new Date();
      const timeRemaining =
        interval -
        (now.getTime() - getStartOfInterval(now, interval).getTime());

      timeout = setTimeout(() => {
        setResult(getStartOfInterval(new Date(), interval));
        scheduleUpdate();
      }, timeRemaining);
    }
  }, [interval]);

  return result;
}
